export const PATCH_USER_SUCCESS = 'SETTINGS/PATCH_USER_SUCCESS';
export const PATCH_USER_ERROR = 'SETTINGS/PATCH_USER_ERROR';
export const CLEAR_PATCH_USER = 'SETTINGS/CLEAR_PATCH_USER';

// CUSTOM DOMAIN
export const ADD_CUSTOM_DOMAIN_SUCCESS = 'SETTINGS/ADD_CUSTOM_DOMAIN_SUCCESS';
export const ADD_CUSTOM_DOMAIN_ERROR = 'SETTINGS/ADD_CUSTOM_DOMAIN_ERROR';
export const CLEAR_CUSTOM_DOMAIN = 'SETTINGS/CLEAR_CUSTOM_DOMAIN';

export const FETCH_CUSTOM_DOMAIN_INFO = 'SETTINGS/FETCH_CUSTOM_DOMAIN_INFO';
export const FETCH_CUSTOM_DOMAIN_INFO_ERROR = 'SETTINGS/FETCH_CUSTOM_DOMAIN_INFO_ERROR';
export const CLEAR_CUSTOM_DOMAIN_INFO = 'SETTINGS/CLEAR_CUSTOM_DOMAIN_INFO';

export const DELETE_CUSTOM_DOMAIN_SUCCESS = 'SETTINGS/DELETE_CUSTOM_DOMAIN_SUCCESS';
export const DELETE_CUSTOM_DOMAIN_ERROR = 'SETTINGS/DELETE_CUSTOM_DOMAIN_ERROR';
export const CLEAR_DELETE_CUSTOM_DOMAIN = 'SETTINGS/CLEAR_DELETE_CUSTOM_DOMAIN';
// END CUSTOM DOMAIN
